// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__10lCW","error":"Button_error__3qC7Y","success":"Button_success__E5vip","primary":"Button_primary__3HmPI"};